import { Modal } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  visible: boolean;
  title: string;
  description: string;
  isLoading: boolean;
  onConfirm(): void;
  onClose(): void;
}

function ConfirmationModal({
  visible,
  title,
  description,
  isLoading,
  onConfirm,
  onClose,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onClose}
      onOk={onConfirm}
      okButtonProps={{
        loading: isLoading,
      }}
      cancelText={t("no")}
      okText={t("yes")}
      destroyOnClose
    >
      <p>{description}</p>
    </Modal>
  );
}

export default ConfirmationModal;
